'use strict';

define(['jquery', 'handlebars', 'videoObjectTemplate'], function ($, handlebars, videoObjectTemplate) {

  var $mediaGallery = $('.child-video-wrap'),
      $mediaChildren = $mediaGallery.find('.media-content');

  $mediaChildren.click(function () {
    var $this = $(this),
        videoUrl = $this.find('.main-video-nav').attr('href'),
        template = videoObjectTemplate(videoUrl);

    $('.main-video-wrap').html(template);

    return false;
  });
});
//# sourceMappingURL=video-object-toggle.js.map
